<template>
  <div>
    <CardRevealImageList v-if="!selectCustom" @select-image="openImageAdder" @close-adder="selectCustom = false" />
    <CardRevealImageAdder v-else @close-adder="selectCustom = false" :position="position" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CardRevealImageList from './CardRevealImageList.vue';
import CardRevealImageAdder from './CardRevealImageAdder.vue';

export default {
  data() {
    return {
      position: null,
      selectCustom: false,
    };
  },

  components: { CardRevealImageList, CardRevealImageAdder },

  computed: {
    ...mapState([]),
  },

  methods: {
    openImageAdder(position) {
      this.position = position;
      this.selectCustom = true;
    },
  },
};
</script>
